/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { Box, Dialog, DialogContent } from '@mui/material';
import { LuceneQueryUtils } from '@vamstar/fox-api-common/esm/utils';

import { ElasticDslQueryViewer } from './ElasticDslQueryViewer';
import { ElasticDslEntitlementContext } from './ElasticDslEntitlementContext';
import { ElasticDslDialogActions } from './ElasticDslDialogActions';
import { ElasticDslOperators } from './ElasticDslOperators';
import { ElasticDslQueryInput } from './ElasticDslQueryInput';

interface IElasticDslEntitlementQueryFormProps {
  open: boolean;
  onClose: () => void;
}

export const ElasticDslEntitlementQueryForm = (props: IElasticDslEntitlementQueryFormProps) => {
  const { open, onClose } = props;
  const { query } = useContext(ElasticDslEntitlementContext);
  const ref = useRef<HTMLDivElement | null>(null);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setDisabled(!LuceneQueryUtils.isLuceneQuery(query));
    return () => {};
  }, [query]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogContent>
        <Box display="flex" flexDirection="column" rowGap={2}>
          <ElasticDslQueryInput disabled={disabled} />
          <Box display="flex" flexDirection="column" rowGap={2} width="100%">
            <ElasticDslOperators
              disabled={disabled}
              focusTextField={() => {
                if (ref) {
                  const { current } = ref;
                  if (current) {
                    current.focus();
                  }
                }
              }}
            />
          </Box>
          <ElasticDslQueryViewer disabled={disabled} />
        </Box>
      </DialogContent>
      <ElasticDslDialogActions onClose={onClose} disabled={disabled} />
    </Dialog>
  );
};
